import React from 'react';
import SVGDownBoldChevron from '../../assets/svgs/down_bold_chevron';
import SVGLock from '../../assets/svgs/lock';
import SVGProfile from '../../assets/svgs/profile_info';
import SVGRefresh from '../../assets/svgs/refresh';
import SVGTurnBack from '../../assets/svgs/turn_back';
import { isUrl } from '../../utils/isUrl';
import { useOutsideClick } from '../../utils/useOutsideClick';
import { useSelector } from 'react-redux/es/hooks/useSelector';
import { useNavigate } from 'react-router-dom';
import Plans from '../DashboardPages/Plans';
import { QuestionMark } from '../../assets/svgs';
const AppDropdown = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const ref = React.useRef<HTMLDivElement>(null);

  const myAppsData = useSelector((state: any) => state.myAppsSlice.localReduxData);

  const app = myAppsData?.app;
  const navigate = useNavigate();
  useOutsideClick(ref, () => {
    setIsOpen(false);
  });
  const dummy =
    'https://cdn.dribbble.com/userupload/11926486/file/original-2d8002832f7422a2eccf148b170e5cca.png?resize=70x70';

  const dropdownLinkItems = {
    // PROFILE: {
    //   id: 2,
    //   title: 'Profil',
    //   icon: {
    //     component: SVGProfile,
    //     classNames: 'stroke-[#8A92A6]',
    //   },
    //   pointTo: '/dashboard/profile',
    //   isDisabled: true
    // },
    // PASSWORD: {
    //   id: 1,
    //   title: 'Şifre Değiştir',
    //   icon: {
    //     component: SVGLock,
    //     classNames: 'stroke-[#8A92A6]',
    //   },
    //   pointTo: '/dashboard/change-password',
    //   isDisabled: true
    // },
    HELP: {
      id: 2,
      title: 'Yardım',
      icon: {
        component: QuestionMark,
        classNames: 'stroke-[#8A92A6] fill-[#8A92A6]',
      },
      pointTo: '/dashboard/help',
      isDisabled: true,
    },
    TURNBACK: {
      id: 1,
      title: 'Uygulamalarıma Dön',
      icon: {
        component: SVGTurnBack,
        classNames: 'stroke-[#8A92A6]',
      },
      pointTo: '/chooseApp',
      isDisabled: false,
    },
  };
  return (
    <div className="flex flex-col relative" ref={ref}>
      <div
        onClick={() => setIsOpen(!isOpen)}
        className="cursor-pointer gap-3 md:gap-0 md:w-[200px] rounded-[10px] border-1.5 border-[#E3E8EF] h-[45px] flex items-center justify-between p-[7px] pr-[15px]"
      >
        <div className="flex items-center gap-[10px]">
          <div className="w-[36px] h-[36px] rounded-[5px]">
            <img src={app.appLogo || dummy} alt="appLogo" className="w-full h-full object-contain rounded-[5px]" />
          </div>
          <div className="hidden md:flex flex-col justify-start">
            <div className="text-[15px] leading-[18.15px] text-[#1E1E1E]">{app?.mobileAppName}</div>
            <div className="text-[13px] leading-[14.52px] text-[#8A92A6]">{app?.isPublished}</div>
          </div>
        </div>
        <div>
          <SVGDownBoldChevron />
        </div>
      </div>
      <div
        className={`absolute top-[55px] right-0 bg-white z-30 flex-col ${isOpen ? 'flex' : 'hidden'
          } w-[220px] h-auto border border-[#E3E8EF] rounded-[10px]`}
      >
        {/* <div className="flex items-center justify-between h-10 w-full p-[15px] mt-[10px]">
          <div className="flex gap-[15px] flex-row items-center">
            {apps?.map((singleApp: any) => {
              return (<>
                <div className="w-[40px] h-[40px] rounded-[5px]">
                  <img src={singleApp?.appIcon || dummy} alt="appIcon" className="w-full h-full rounded-[5px]" />
                </div>
                <div className="hidden md:flex flex-col justify-start">
                  <div className="text-[15px] leading-[18.15px] text-[#1E1E1E]">{singleApp?.name}</div>
                  {singleApp?.isPublished && <div className="text-[13px] leading-[14.52px] text-[#8A92A6]">{singleApp?.isPublished}</div>}
                </div>
              </>)
            })}
          </div> 
          <div className="cursor-pointer">
            <SVGRefresh />
          </div>
        </div> */}
        <div className="w-full p-[11px] flex flex-col justify-between h-full">
          {Object.values(dropdownLinkItems)?.map(dropdownLinkItem => {
            const icon = dropdownLinkItem?.icon;
            const pointTo = dropdownLinkItem?.pointTo;
            return (
              <div
                className={`flex items-center gap-[15px] hover:bg-[#F7F8FA] rounded-[5px] cursor-pointer p-1 ${dropdownLinkItem.isDisabled ? 'opacity-50 pointer-events-none cursor-notallowed' : ''
                  }`}
                onClick={() => {
                  navigate(pointTo);
                }}
              >
                <div className="w-[30px] h-[30px] rounded-[5px] bg-[#E3E8EF] flex justify-center items-center">
                  <icon.component className={` shrink-0  duration-0 ${icon.classNames}`}></icon.component>
                </div>
                <span className="text-[14px] leading-[16.94px] text-[#8A92A6]">{dropdownLinkItem?.title}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default AppDropdown;
